<template>
  <div class="w-full flex flex-col items-stretch justify-items-stretch">
    <sg-spacing y-xs>
      <slot>
        <input
          v-bind="$attrs"
          :value="value"
          @input="$emit('input', $event.target.value)"
          class="p-3 border-gray-300 rounded-xl w-full focus:border-navy-600 focus:ring-0"
          ref="input"
        />
      </slot>
    </sg-spacing>
    <sg-text small light-gray v-if="tip">{{ tip }}</sg-text>
    <sg-input-error :error="error" />
  </div>
</template>

<script>
export default {
  props: {
    error: { type: String, default: null },
    tip: { type: String, default: null },
    value: { type: String, default: null },
  },

  inheritAttrs: false,
};
</script>
